// Page copy for the redesigned Studio. Keep enUS and zhCN structurally identical.
export const enUS = {
  title: 'Subscriptions',
  sections: {
    plan: 'Your plan',
    credits: 'Add credits',
    avatarCreations: 'Add Avatar Creations',
    billing: 'Payments & invoices',
  },
  back: 'Back to Subscriptions',
  balance: {
    addCredits: 'Add credits',
    addCreations: 'Add creations',
  },
  currentPlan: {
    title: 'Current plan',
    active: 'Active',
    noRecurring: 'No recurring charge',
    customPricing: 'Custom pricing',
    monthlyBilling: 'Monthly billing · {price}',
    annualBilling: 'Annual billing · {price}',
    renews: 'Renews {date}',
    manageBilling: 'Manage billing',
  },
  choose: {
    title: 'Choose your plan',
    cycle: 'Billing cycle',
    monthly: 'Monthly',
    annual: 'Annual · save up to 20%',
    billedMonthly: '{price} billed monthly',
    billedAnnually: '{price} billed annually',
    choosePlan: 'Choose {name}',
    upgrade: 'Upgrade',
    downgrade: 'Downgrade',
    startFree: 'Start Free',
    currentPlan: 'Current plan',
    loading: 'Loading plans',
    features: {
      credits: '{count} credits / month',
      concurrency: '{count} concurrent sessions',
      concurrencyOne: '1 concurrent session',
      concurrencyUnlimited: 'Unlimited concurrent sessions',
      session: '{minutes} min per session',
      sessionUnlimited: 'No session time limit',
    },
  },
  enterprise: {
    title: 'Enterprise',
    description: 'Custom pricing, concurrency and Avatar Creations, with dedicated support',
    action: 'Contact sales',
  },
  comparison: {
    title: 'Compare all features',
    caption: 'Monthly allowances stay the same with annual billing',
    included: 'Included in your plan',
    region: 'Plan feature comparison',
  },
  policy: {
    upgradeTitle: 'Upgrade when you need more',
    upgradeBody: 'Changes take effect after payment confirmation. Checkout shows any prorated charge.',
    downgradeTitle: 'Downgrade at renewal',
    downgradeBody: 'Your current plan stays active until the billing period ends. Cancelling moves your account to Free.',
  },
  reload: {
    title: 'Auto-reload',
    emptyTitle: 'Auto-reload is currently unavailable',
    emptyBody: 'No auto-reload packages are available for your account.',
    enabled: 'Enabled',
    disabled: 'Disabled',
    description: 'Automatically buy a credit pack when your balance runs low',
    paidOnlyTitle: 'Available on paid plans',
    paidOnlyBody: 'Choose a paid subscription to enable automatic reloads',
    comparePlans: 'Compare plans',
    threshold: 'When credits fall below',
    thresholdOption: '{count} credits',
    pack: 'Add this pack',
    packOption: '{credits} credits · {price}',
    explanation: 'When you have fewer than {threshold} credits, we charge {price} to add {credits} credits.',
    explanationCard: 'When you have fewer than {threshold} credits, we charge {brand} •••• {last4} {price} to add {credits} credits.',
    changeCard: 'Change card in Stripe',
    terms: 'Automatic Payment Authorization Terms',
    consentEnable: 'By clicking “Enable auto-reload”, you agree to the {terms} and authorize Spatialwalk PTE LTD to automatically charge your selected payment method using the threshold and amount per top-up shown above. Multiple top-ups may occur on the same day. You can disable auto-reload at any time.',
    consentSave: 'By clicking “Save changes”, you agree to the {terms} and authorize Spatialwalk PTE LTD to automatically charge your selected payment method using the updated threshold and amount per top-up shown above. Multiple top-ups may occur on the same day. You can disable auto-reload at any time.',
    disableNote: 'Disabling stops new automatic top-ups without canceling your subscription. Payments already submitted may still complete.',
    enable: 'Enable auto-reload',
    save: 'Save changes',
    disable: 'Disable auto-reload',
    loading: 'Loading auto-reload settings',
  },
  payments: {
    title: 'Payment details',
    description: 'Manage payment methods, invoices and subscription cancellation in the billing portal',
    method: 'Saved payment method',
    methodPortal: 'Managed in Stripe',
    currency: 'Billing currency',
    next: 'Next subscription payment',
    noRecurring: 'No recurring payment',
    action: 'Manage payments & invoices',
    freeTitle: 'No billing portal on the Free plan',
    freeBody: 'Payment methods and invoices become available once you subscribe to a paid plan.',
    explainerTitle: 'Looking for usage records?',
    explainerBody: 'Invoices show what you paid. Usage records your credit consumption.',
    explainerAction: 'View Usage',
  },
  packs: {
    title: 'Choose a pack',
    available: '{count} available',
    unit: 'Avatar Creation',
    units: 'Avatar Creations',
    each: '{price} each',
    single: 'Single purchase',
    save: 'Save {percent}%',
    buy: 'Buy for {price}',
    enterprise: 'Need more than {count}?',
    enterpriseAction: 'Contact sales',
    enterpriseTail: 'for custom volume and dedicated support.',
  },
}

export const zhCN = {
  title: '订阅',
  sections: {
    plan: '我的套餐',
    credits: '购买 Credits',
    avatarCreations: '购买 Avatar Creations',
    billing: '付款与发票',
  },
  back: '返回订阅',
  balance: {
    addCredits: '购买 Credits',
    addCreations: '购买创建次数',
  },
  currentPlan: {
    title: '当前套餐',
    active: '生效中',
    noRecurring: '无周期性扣费',
    customPricing: '定制价格',
    monthlyBilling: '按月计费 · {price}',
    annualBilling: '按年计费 · {price}',
    renews: '{date} 续费',
    manageBilling: '管理账单',
  },
  choose: {
    title: '选择套餐',
    cycle: '计费周期',
    monthly: '月付',
    annual: '年付 · 最高省 20%',
    billedMonthly: '每月支付 {price}',
    billedAnnually: '每年支付 {price}',
    choosePlan: '选择 {name}',
    upgrade: '升级',
    downgrade: '降级',
    startFree: '免费开始',
    currentPlan: '当前套餐',
    loading: '正在加载套餐',
    features: {
      credits: '每月 {count} credits',
      concurrency: '{count} 路并发会话',
      concurrencyOne: '1 路并发会话',
      concurrencyUnlimited: '不限并发会话',
      session: '单次会话 {minutes} 分钟',
      sessionUnlimited: '单次会话不限时长',
    },
  },
  enterprise: {
    title: '企业版',
    description: '定制价格、并发数与 Avatar Creations，并提供专属支持',
    action: '联系销售',
  },
  comparison: {
    title: '功能对比',
    caption: '年付与月付的每月额度相同',
    included: '套餐包含',
    region: '套餐功能对比',
  },
  policy: {
    upgradeTitle: '随时升级',
    upgradeBody: '升级在付款确认后生效，结账页会显示按比例折算的费用。',
    downgradeTitle: '降级在续费时生效',
    downgradeBody: '当前套餐会保留到本计费周期结束。取消订阅后账户将转为免费版。',
  },
  reload: {
    title: '自动充值',
    emptyTitle: '自动充值暂不可用',
    emptyBody: '当前账户暂无可用的自动充值套餐。',
    enabled: '已开启',
    disabled: '未开启',
    description: '余额不足时自动购买 Credits 套餐',
    paidOnlyTitle: '仅付费套餐可用',
    paidOnlyBody: '订阅付费套餐后即可开启自动充值',
    comparePlans: '对比套餐',
    threshold: '当 credits 低于',
    thresholdOption: '{count} credits',
    pack: '充值套餐',
    packOption: '{credits} credits · {price}',
    explanation: '当你的 credits 少于 {threshold} 时，我们会扣款 {price} 充入 {credits} credits。',
    explanationCard: '当你的 credits 少于 {threshold} 时，我们会从 {brand} •••• {last4} 扣款 {price} 充入 {credits} credits。',
    changeCard: '在 Stripe 更换银行卡',
    terms: '《自动扣款授权条款》',
    consentEnable: '点击「开启自动充值」，即表示你同意{terms}，授权 Spatialwalk PTE LTD 按上述触发阈值和单笔金额，通过你选择的支付方式自动扣款。充值可能在同一天多次发生，你可以随时关闭自动充值。',
    consentSave: '点击「保存更改」，即表示你同意{terms}，授权 Spatialwalk PTE LTD 按上述更新后的触发阈值和单笔金额，通过你选择的支付方式自动扣款。充值可能在同一天多次发生，你可以随时关闭自动充值。',
    disableNote: '关闭后将停止发起新的自动充值，不会取消订阅。此前已提交处理的付款仍可能完成。',
    enable: '开启自动充值',
    save: '保存更改',
    disable: '关闭自动充值',
    loading: '正在加载自动充值设置',
  },
  payments: {
    title: '付款信息',
    description: '在账单门户中管理付款方式、发票和取消订阅',
    method: '已保存的付款方式',
    methodPortal: '由 Stripe 管理',
    currency: '结算货币',
    next: '下次订阅付款',
    noRecurring: '无周期性付款',
    action: '管理付款与发票',
    freeTitle: '免费版没有账单门户',
    freeBody: '订阅付费套餐后即可管理付款方式和发票。',
    explainerTitle: '想查看用量记录？',
    explainerBody: '发票记录你支付的费用，用量记录你的 credits 消耗。',
    explainerAction: '查看用量',
  },
  packs: {
    title: '选择套餐',
    available: '可用 {count}',
    unit: 'Avatar Creation',
    units: 'Avatar Creations',
    each: '每个 {price}',
    single: '单次购买',
    save: '省 {percent}%',
    buy: '以 {price} 购买',
    enterprise: '需要超过 {count} 个？',
    enterpriseAction: '联系销售',
    enterpriseTail: '获取定制数量和专属支持。',
  },
}
